<template>
  <a-row :gutter="[16,16]">
    <a-col>
      <a-card hoverable>
        <a-card-meta :title="nombre" :description="identificacion">
          <a-avatar
            slot="avatar"
            :src="profileSrc"
            @click="agrandarImg()"
            :size="tamanoimg"
          />
        </a-card-meta>
        <template class="ant-card-actions" slot="actions">
          <a-progress style="width: 80%" :percent="100" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }" />
        </template>
      </a-card>
    </a-col>
    <a-modal @ok="() => {this.expandImg = false}" :cancel-button-props="{props: { disabled: true } }" width="400px" v-model="expandImg" :title="nombre" >
      <a-card hoverable style="width: auto">
      <img
        slot="cover"
        :src="profileSrc"
      />
      </a-card>
    </a-modal>
  </a-row>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        expandImg: false,
        defaultPicture: require('./../../assets/anon_profile.png'),
        profileSrc: require('./../../assets/anon_profile.png')
      }
    },
    props: ['persona', 'tamanoimg'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.identificacion && this.loadPersonPicture(this.identificacion)
    },
    methods: {
      agrandarImg () {
        this.expandImg = true
      },
      loadPersonPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      }
    },
    watch: {
      persona () {
        this.identificacion && this.loadPersonPicture(this.identificacion)
      }
    },
    computed: {
      nombre () {
        if (!JsUtils.isEmpty(this.persona.identificacion) && !JsUtils.isEmpty(this.persona.nombre)) {
          this.persona.last_name2 = JsUtils.isEmpty(this.persona.last_name2) ? '' : this.persona.last_name2
          this.persona.last_name1 = JsUtils.isEmpty(this.persona.last_name1) ? '' : this.persona.last_name1
          return JsUtils.isEmpty(this.persona) ? '' : (JsUtils.isEmpty(this.persona.nombre + ' ' + this.persona.last_name1 + ' ' + this.persona.last_name2) ? '' : this.persona.nombre + ' ' + this.persona.last_name1 + ' ' + this.persona.last_name2)
        } else {
          return ''
        }
      },
      identificacion () {
        return JsUtils.isEmpty(this.persona) ? '' : (JsUtils.isEmpty(this.persona.identificacion) ? '' : this.persona.identificacion)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataResumen.vue